import { useState, useEffect } from 'react';
import apiService from '../services/apiService';
import './DocSuggestionModal.css';

export default function DocSuggestionModal({ isOpen, onClose }) {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [deviceHint, setDeviceHint] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!title.trim()) { setError('Bitte einen Titel eingeben.'); return; }
    if (description.trim().length < 10) { setError('Bitte eine ausführlichere Beschreibung eingeben (mind. 10 Zeichen).'); return; }
    setError('');
    setLoading(true);
    try {
      await apiService.submitDocSuggestion(title.trim(), description.trim(), deviceHint.trim());
      setSuccess(true);
    } catch (err) {
      setError(err.message || 'Fehler beim Einreichen.');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (loading) return;
    setTitle('');
    setDescription('');
    setDeviceHint('');
    setError('');
    setSuccess(false);
    onClose();
  };

  return (
    <div className="docsugg-overlay" onClick={handleClose}>
      <div className="docsugg-modal" onClick={(e) => e.stopPropagation()}>

        {/* Header */}
        <div className="docsugg-header">
          <div className="docsugg-header-left">
            <span className="docsugg-header-icon">💡</span>
            <div>
              <h2>Dokumentations-Vorschlag</h2>
              <p>Fehlt eine Dokumentation? Sag es uns!</p>
            </div>
          </div>
          <button className="docsugg-header-close" onClick={handleClose} disabled={loading}>✕</button>
        </div>

        {success ? (
          <>
            <div className="docsugg-success-body">
              <div className="docsugg-success-circle">✓</div>
              <p className="docsugg-success-title">Vorschlag eingereicht!</p>
              <p className="docsugg-success-text">
                Vielen Dank! Dein Vorschlag wird von einem Key-Techniker oder Administrator geprüft.
              </p>
            </div>
            <div className="docsugg-success-footer">
              <button className="docsugg-btn-close" onClick={handleClose}>Schließen</button>
            </div>
          </>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="docsugg-body">

              <div className="docsugg-info-note">
                <span className="docsugg-info-icon">📌</span>
                <span>Vermisst du eine Dokumentation? Mach einen Vorschlag – Key-Techniker und Admins können ihn prüfen und umsetzen.</span>
              </div>

              <div className="docsugg-field">
                <label htmlFor="docsugg-title">
                  Titel <span className="docsugg-required">*</span>
                </label>
                <input
                  id="docsugg-title"
                  type="text"
                  value={title}
                  onChange={e => { setTitle(e.target.value); setError(''); }}
                  placeholder="z.B. Bedienungsanleitung für Gerät X"
                  maxLength={255}
                  autoFocus
                />
              </div>

              <div className="docsugg-field">
                <label htmlFor="docsugg-device">
                  Gerät / Bereich <span className="docsugg-optional">(optional)</span>
                </label>
                <input
                  id="docsugg-device"
                  type="text"
                  value={deviceHint}
                  onChange={e => setDeviceHint(e.target.value)}
                  placeholder="z.B. Kaffeemaschine Modell Y, Kasse, etc."
                  maxLength={255}
                />
              </div>

              <div className="docsugg-field">
                <label htmlFor="docsugg-desc">
                  Beschreibung <span className="docsugg-required">*</span>
                  <span className="docsugg-char">{description.length} Zeichen</span>
                </label>
                <textarea
                  id="docsugg-desc"
                  value={description}
                  onChange={e => { setDescription(e.target.value); setError(''); }}
                  placeholder="Was soll dokumentiert werden? Warum ist das wichtig?"
                  rows={5}
                  minLength={10}
                />
              </div>

              {error && <p className="docsugg-error">⚠️ {error}</p>}

            </div>
            <div className="docsugg-footer">
              <button type="button" className="docsugg-btn-cancel" onClick={handleClose} disabled={loading}>
                Abbrechen
              </button>
              <button type="submit" className="docsugg-btn-submit" disabled={loading}>
                {loading ? '⏳ Wird eingereicht…' : '💡 Vorschlag einreichen'}
              </button>
            </div>
          </form>
        )}

      </div>
    </div>
  );
}

